function safeUnref(timer) {
  if (typeof timer === "object" && typeof timer.unref === "function") {
    timer.unref();
  }
  return timer;
}

export { safeUnref };
//# sourceMappingURL=timer.js.map
